import React from "react";

export const ExtendedTableChart = ({ dataSet, def }) => {
	let header = null;

	if (def.format.columns && def.format.columns[0]) {
		header = (
			<div className="w-full text-center uppercase text-lg mb-3">
				{def.format.columns[0].title.replace(":", "")}
			</div>
		);
	}

	const rows = dataSet.data.map((e, rowIndex) => {
		if (e?.text) {
			let text = e.text || "";
			if (Array.isArray(text)) {
				text = text.join(", ");
			}
			return (
				<div className="w-full flex ml-2 md:mr-4 text-sm">
					<span
						className={e.textClass}
						dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, "<br/>") }}
					></span>
				</div>
			);
		} else if (e?.value) {
			return (
				<div className="w-full ml-2 md:mr-4 text-sm">
					<span className={`font-bold ${e.preambleClass}`}>{e.preamble}</span>:
					<span
						className={` pl-1 ${e.valueClass}`}
						dangerouslySetInnerHTML={{
							__html: e.value.replace(/\n/g, "<br/>"),
						}}
					></span>
				</div>
			);
		} else {
			return (
				<div
					className={`w-full flex text-md uppercase ${
						rowIndex === 0 ? "" : "mt-2"
					} mb-1`}
				>
					<div className={e.preambleClass || e.headerClass}>
						{e.preamble || e.header}
					</div>
				</div>
			);
		}
	});

	if (!rows || !rows.length) {
		return <div className="mt-4 text-center text-base">No data available</div>;
	}

	return (
		<>
			{header}
			{rows}
		</>
	);
};
